import ArrowUp from '../../atoms/icons/arrowUp';
import Container from '../../atoms/container/channelArrowUpContainer';
import { useAppDispatch } from '../../../../shared/store/hooks';
import { channelUp } from '../../../../shared/store/thunks/channels.thunk';

function ChannelUp() {
  const dispatch = useAppDispatch();
  return (
    <Container
      onClick={() => {
        dispatch(channelUp());
      }}
    >
      <ArrowUp />
    </Container>
  );
}

export default ChannelUp;
